<script>
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useModalStore } from "@/stores/modal.js";
import { useGarageStore } from "@/stores/garage.js";

export default {
  setup() {
    // I18n
    const { t } = useI18n();
    const translationPrefix = ref('modal.completed_service');

    // Stores
    const modalStore = useModalStore();
    const garageStore = useGarageStore();

    // Variables
    const isLoading = ref(true);

    onMounted(async () => {});

    return {
      t,
      translationPrefix,
      modalStore,
      garageStore,
      isLoading,
    }
  },
};
</script>

<template>
  <div class="flex flex-col space-y-4 w-full px-8 py-4">
      <!-- <div class="w-full">
        <p class="font-semibold text-lg modal-header">{{ t(`${translationPrefix}.modal_body`) }}</p>
        <p class="text-md text-gray-600">{{ t(`${translationPrefix}.modal_body_text`) }}</p>
      </div>
      <div class="w-full">
        <label for="garage_name" class="block text-gray-600 font-semibold">{{ t(`${translationPrefix}.garage_name_label`) }}</label>
        <input type="text" id="garage_name" name="garage_name" v-model="modalStore.newGarage.name" class="w-full mt-1 p-2 px-4 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-purple-300" :placeholder="t(`${translationPrefix}.garage_name_placeholder`)">
      </div>
      <div class="w-full">
        <label for="garage_description" class="block text-gray-600 font-semibold">{{ t(`${translationPrefix}.garage_description_label`) }}</label>
        <textarea id="garage_description" name="garage_description" v-model="modalStore.newGarage.description" class="w-full mt-1 p-2 px-4 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-purple-300" :placeholder="t(`${translationPrefix}.garage_description_placeholder`)" />
      </div> -->
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/styles/components/modals/garage';
</style>
